// /src/store/store.ts

import { createStore     ,
         applyMiddleware }  from 'redux';
import {  thunk          }  from 'redux-thunk';

import   reducers           from './generalReducer';

export const store = createStore (
  reducers                ,
  {}                      ,
  applyMiddleware (thunk)
);

export type AppDispatch = typeof store.dispatch;
